import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-f1b6082c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w1200" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "z-header__mini"
}
const _hoisted_6 = { class: "z-header__menu" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("校招职位")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("招聘动态")
const _hoisted_9 = { class: "z-header__login" }
const _hoisted_10 = {
  key: 1,
  style: {"display":"inline-block"}
}
const _hoisted_11 = { class: "el-dropdown-link" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("我的简历")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("我的申请")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("我的收藏")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("退出")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_zswitch = _resolveComponent("zswitch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.$isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(['z-header', _ctx.type == 'transparent' ? 'transparent' : ''])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "z-header__logo",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogoClick && _ctx.handleLogoClick(...args)))
              }, _hoisted_4),
              (_ctx.title && _ctx.currentRouteName != 'Home')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.title), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    class: _normalizeClass({ active: _ctx.currentRouteName == 'Home' }),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toPage('Home')))
                  }, "首页", 2),
                  _createElementVNode("li", {
                    class: _normalizeClass({ active: _ctx.menuActive == 1 && _ctx.currentRouteName != 'Home' }),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toPage('social')))
                  }, " 社会招聘 ", 2),
                  _createElementVNode("li", {
                    class: _normalizeClass({ active: _ctx.menuActive == 2 })
                  }, [
                    _createVNode(_component_el_dropdown, null, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toPage('CampusPosition')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toPage('ecologyDetail')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "el-dropdown-link",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toPage('campus')))
                        }, "校园招聘")
                      ]),
                      _: 1
                    })
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass({ active: _ctx.menuActive == 3 }),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toPage('blue')))
                  }, "一线招聘", 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                (!_ctx.userIsLogin)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "z-login",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toLogin && _ctx.toLogin(...args)))
                    }, "登录"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_el_dropdown, null, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, {
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toPage('myResume')))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_12
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toPage('myApply')))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_dropdown_item, {
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toPage('myLike')))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_14
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_dropdown_item, { onClick: _ctx.loginOut }, {
                                default: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_11, [
                            _createTextVNode(_toDisplayString(_ctx.store.state.userInfo.nickName) + " ", 1),
                            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_arrow_down)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]))
              ])
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$isMobile && !_ctx.hasChange)
      ? (_openBlock(), _createBlock(_component_zswitch, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}